import { queryClient as apiQueryClient } from '@frontend/api';

export const invalidateBomTableQueriesForComponentIds = ({
  componentIds,
}: {
  componentIds: number[];
}) => {
  // invalidate queries for BOM table for the respective component ids
  const stringIds = componentIds.map((cid) => cid.toString());
  apiQueryClient.invalidateQueries({
    predicate: (query) =>
      query.queryKey[0] === 'bomTable' &&
      query.queryKey[1] &&
      stringIds.includes(query.queryKey[1].toString()),
  });
};

export const invalidateAllBomTableQueries = () => {
  apiQueryClient.invalidateQueries(['bomTable']);
};
